<template>
    <div class="card-styles--setting card-styles--club">
        <h2>4. Escudo</h2>
        <div>
            <button @click="openFilePlayer" class="uploadImageButton button1">
                <span>Subir Imagen</span>
            </button>
            <input type="file" id="escudoImageUpload" accept="image/*" @change="uploadImageEscudo" style="display: none" ref="fileInput">
            <p v-if="errorMessageEscudo">{{ errorMessageEscudo }}</p>

        </div>

    </div>
</template>

<script>
export default {
    props: ['errorMessageEscudo'],

    methods: {
        // check to import from App.vue the entire esudo upload function only once used here
        uploadImageEscudo(event) {
            this.$emit('changeEscudoImage', event.target.files[0]);
        },
        openFilePlayer() {
            this.$refs.fileInput.click();
        }
    }
}
</script>

<style>

</style>